import { toTitleCase } from '@/utils/casing-util/casingUtil'

const DEFAULT_SEVERITY = 'secondary'

/**
 * Looks a stored value up in a severity map. Null, empty and unknown values read as `secondary`.
 *
 * @example resolveSeverity({ VARIABLE: 'info' }, 'VARIABLE') // 'info'
 * @example resolveSeverity({ VARIABLE: 'info' }, null) // 'secondary'
 */
export const resolveSeverity = <Severity extends string>(
  severities: Readonly<Record<string, Severity | null | undefined>>,
  key: string | null | undefined
): Severity | typeof DEFAULT_SEVERITY => (key ? (severities[key] ?? DEFAULT_SEVERITY) : DEFAULT_SEVERITY)

/**
 * Looks a stored value up in a label map. An unknown value reads as its title case.
 * Null and empty read as `emptyLabel`.
 *
 * @example resolveLabel({ single: 'Single Selection' }, 'multi_pick') // 'Multi Pick'
 * @example resolveLabel({}, null, '—') // '—'
 */
export const resolveLabel = (
  labels: Readonly<Record<string, string>>,
  key: string | null | undefined,
  emptyLabel = ''
): string => (key ? (labels[key] ?? toTitleCase(key)) : emptyLabel)
